enum DemandState {
    PENDING = 'PENDING',
    INTERNAL = 'INTERNAL',
    FOR_EMPLOYMENT = 'FOR_EMPLOYMENT'
}

export default DemandState